export default __webpack_public_path__ + "static/media/slider-info-left-dark-1.2359b3bf.png";